import { Container } from '@grupoboticario/flora-react'
import { PropsWithChildren } from 'react'

export const HomeContainer = ({ children }: PropsWithChildren<{}>) => {
  return <Container size="large">{children}</Container>
}
